import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import { Editor } from "./pages/Editor";
import { BlogView } from "./pages/BlogView";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { RouteLogger } from "./components/RouteLogger";
import { isAxiomEnabled, WebVitals } from "./services/axiom";

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        {isAxiomEnabled && <WebVitals />}
        <RouteLogger />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog/:slug" element={<BlogView />} />
          <Route path="/edit/:id" element={<Editor />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
